import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Text } from "@/components/ui/text";
import { AppDrawer } from "@components";
import { A } from "@solidjs/router";
import { Presentation } from "lucide-solid";
import { rrulestr } from "rrule"; // 1. Import rrulestr
import { createMemo } from "solid-js";
import { useService } from "solid-services";
import { Flex, Grid } from "styled-system/jsx";
import { useCalendarState } from "../../../../state/events/calendar-state";
import Admin from "./Admin";

export default function () {
  const { activeEvent, setActiveEvent } = useService(useCalendarState)();

  // 2. Create a memo to parse the string into a human-readable format
  const readableRRule = createMemo(() => {
    const ruleString = activeEvent()?.rrule;
    if (!ruleString) return "One-time event";

    try {
      // rrulestr converts the string to an RRule object
      return rrulestr(ruleString).toText();
    } catch (e) {
      console.error("Invalid RRULE string:", e);
      return ruleString; // Fallback to raw string if parsing fails
    }
  });

  return (
    <AppDrawer
      size='md'
      open={!!activeEvent()?.id}
      onOpenChange={({ open }) => !open && setActiveEvent()}
      title={activeEvent()?.group ?? ''}
    >
      <Grid height='100%' justifyContent='stretch' gridTemplateRows='1fr auto' w='100%'>
        <Grid alignContent='start' gap="2">
          <Text>{activeEvent()?.description}</Text>
          <Flex justifyContent='space-between' alignItems='center'>
            <Text fontSize='xs' color='fg.muted'>Duration: </Text>
            <Badge textAlign='right'>{activeEvent()?.duration_mins}m</Badge>
          </Flex>
          <Flex justifyContent='space-between' alignItems='center'>
            <Text fontSize='xs' color='fg.muted'>Starting: </Text>
            <Text fontSize='xs'>{activeEvent()?.localTime.format('ddd, MMM D, YYYY HH:mm')}</Text>
          </Flex>
          <Flex justifyContent='space-between' alignItems='center'>
            <Text fontSize='xs' color='fg.muted'>Occurring: </Text>
            <Text fontSize='xs' textAlign='right' textTransform="capitalize">
              {readableRRule()}
            </Text>
          </Flex>
        </Grid>

        <Admin />

        <Flex justifyContent='end' alignItems='center'>
          <A href={activeEvent()?.meeting_url ?? ''}>
            <Button colorPalette='jade' variant='solid'>
              <Presentation />
              Join Event
            </Button>
          </A>
        </Flex>
      </Grid>
    </AppDrawer>
  )
}
